// بيانات الصوت لإذاعة جامعة زايد العسكرية
// استخدام ملفات صوتية محلية من مجلد assest/audio
import track1 from '../assest/audio/1.mp3';
import track2 from '../assest/audio/2.mp3';
import rest1 from '../assest/audio/rest1.mp3';
import rest2 from '../assest/audio/rest2.mp3';
import rest3 from '../assest/audio/rest3.mp3';
import anaAlAlam from '../assest/audio/تحميل-اغنية-أنا-العلم-بلقيس-فتحي.mp3';
import yaAmelna from '../assest/audio/تحميل-اغنية-يا-عملنا-بلقيس-فتحي-وحسين-الجسمي.mp3';
import yaAmelnaKids from '../assest/audio/تحميل-اغنية-يا-عملنا-للأطفال.mp3';
import yahyaAlam from '../assest/audio/تحميل-اغنية-يحيا-علم-اليوم-يومك-يا-علم.mp3';
import eishiBiladi from '../assest/audio/عيشي بلادي.mp3';

export const audioData = [
  {
    id: 6,
    titleAr: "عيشي بلادي",
    duration: "3:50",
    url: eishiBiladi,
    category: "music",
    description: "أغنية وطنية إماراتية",
    libraryCategoryId: 2
  },
  {
    id: 2,
    titleAr: "أنا العلم - بلقيس فتحي",
    duration: "3:45",
    url: anaAlAlam,
    category: "music",
    description: "النشيد الوطني لبلقيس فتحي",
    libraryCategoryId: 2
  },
  {
    id: 3,
    titleAr: "يا عملنا - بلقيس فتحي وحسين الجسمي",
    duration: "4:20",
    url: yaAmelna,
    category: "music",
    description: "أغنية وطنية بالتعاون بين فنانين",
    libraryCategoryId: 2
  },
  {
    id: 4,
    titleAr: "يا عملنا للأطفال",
    duration: "3:30",
    url: yaAmelnaKids,
    category: "music",
    description: "نسخة الأطفال من يا عملنا",
    libraryCategoryId: 2
  },
  {
    id: 5,
    titleAr: "يحيا علم اليوم يومك يا علم",
    duration: "4:00",
    url: yahyaAlam,
    category: "music",
    description: "أغنية احتفال بالعلم الوطني",
    libraryCategoryId: 2
  },
  {
    id: 7,
    titleAr: "المقطع الأول",
    duration: "3:15",
    url: track1,
    category: "music",
    description: "مقطع موسيقي إضافي",
    image: require('../assest/New folder/54-national-day-united-arab-260nw-2363778695.webp'),
    libraryCategoryId: 1
  },
  {
    id: 8,
    titleAr: "المقطع الثاني",
    duration: "3:40",
    url: track2,
    category: "music",
    description: "مقطع موسيقي إضافي",
    libraryCategoryId: 2
  }
];

// الفواصل المقترحة
export const restTracks = [
  {
    id: "rest-1",
    titleAr: "زايد الأرث",
    duration: "0:30",
    url: rest1,
    category: "rest",
    description: "يركز على إرث زايد الإنساني والوطني والممتد حتى اليوم في الشباب والوطن"
  },
  {
    id: "rest-2", 
    titleAr: "روح الوطنية",
    duration: "0:30",
    url: rest2,
    category: "rest",
    description: "فاصل تحفيزي يومي يرفع من روح الوطنية ويعزز المواطنة الصالحة"
  },
  {
    id: "rest-3",
    titleAr: "روح الوطنية", 
    duration: "0:30",
    url: rest3,
    category: "rest",
    description: "مشاركة الجامعة المجتمع بأي إنجاز تحققه الدولة"
  },
  {
    id: "rest-4",
    titleAr: "فخر ورفعة", 
    duration: "0:30",
    url: rest1,
    category: "rest",
    description: "تصاريح سريعة لعدد من الإداريين والأكاديميين وحتى الطلبة"
  }
];

// بيانات البث المباشر
export const liveStream = {
  id: "live-1",
  titleAr: "  إذاعة جامعة زايد العسكرية",
  url: track1,
  isLive: true,
  description: "البث المباشر لإذاعة جامعة زايد العسكرية - احتفالاً بالعيد الوطني 54",
  image: require('../assest/New folder/54-national-day-united-arab-260nw-2363778695.webp')
};
